import { useEffect } from 'react';
import PropTypes from 'prop-types';

export const TitelNotification = ({
  actionsTotalCount,
}) => {
  useEffect(() => {
    const currenttitel = document.title;
    const notificationRemovedTitel = currenttitel.replace(/^\(\d+\) - /g, '');
    if (actionsTotalCount) {
      const titelWithNotifications = `(${actionsTotalCount}) - ${notificationRemovedTitel}`;
      document.title = titelWithNotifications;
    } else {
      document.title = notificationRemovedTitel;
    }
  }, [actionsTotalCount]);
  return null;
};


TitelNotification.propTypes = {
  actionsTotalCount: PropTypes.number,
};

TitelNotification.defaultProps = {
  actionsTotalCount: 0,
};
